export default __webpack_public_path__ + "static/media/referral_dog.1ab5d0ff.webp";